import Coin from "../Coin";
import OpenOrder from "../OpenOrder";
import TradeModel from "../Trade";

/**
 * 📄 Model which combines all the bots stats
 */
export default class TotalBotsStats {
  constructor(
    public totalCurrentBalanceInUse: number,
    public totalTrades: number,
    public netROI: number,
    public bahROI: number,
    public totalStartingBalance: number,
    public totalProfit: number,
    public totalBaHProfit: number,
    public totalVolume: number,
    public totalFeesPaid: number,
    public totalOpenOrders: OpenOrder[],
    public balanceInUsePerCoin: Coin[],
    public totalSharpe: number,
    public totalSortino: number,
    public totalMdd: number
  ) {}
}
